import { CreditCardEssentials } from '@platform-frontend/payment-util';

export interface EditableCreditCard extends CreditCardEssentials {
  type: 'CREDIT_CARD';
  id: number;
}
